export const EditIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
  >
    <g
      stroke="#3F74FF"
      strokeLinejoin="round"
      strokeWidth="1.5"
      clipPath="url(#clip0_1634_1312)"
    >
      <path
        d="M9.382 2.59c.497-.538.745-.807 1.01-.964a2.07 2.07 0 0 1 2.068-.031c.268.149.524.41 1.036.934.512.523.768.784.914 1.058.352.662.34 1.463-.03 2.113-.154.27-.417.524-.944 1.031l-6.27 6.039c-.998.961-1.497 1.442-2.121 1.686s-1.31.226-2.682.19l-.186-.005c-.418-.011-.627-.017-.748-.154-.122-.138-.105-.35-.072-.776l.018-.231c.093-1.198.14-1.796.374-2.335s.637-.975 1.444-1.849zM8.666 2.667l4.667 4.666"></path>
      <path strokeLinecap="round" d="M9.333 14.667h5.333"></path>
    </g>
    <defs>
      <clipPath id="clip0_1634_1312">
        <path fill="#fff" d="M0 0h16v16H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export const AddIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
  >
    <g stroke="#1B9C85" strokeWidth="1.5" clipPath="url(#clip0_1634_1311)">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8 5.333v5.334M10.666 8H5.333"
      ></path>
      <path
        d="M1.666 8c0-2.986 0-4.478.928-5.406.927-.927 2.42-.927 5.406-.927s4.478 0 5.406.927c.927.928.927 2.42.927 5.406s0 4.478-.927 5.406c-.928.927-2.42.927-5.406.927s-4.479 0-5.406-.927c-.928-.928-.928-2.42-.928-5.406Z"></path>
    </g>
    <defs>
      <clipPath id="clip0_1634_1311">
        <path fill="#fff" d="M0 0h16v16H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export const FolderIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
  >
    <g clipPath="url(#clip0_1678_1092)">
      <path
        stroke="#646464"
        strokeLinecap="round"
        strokeWidth="1.5"
        d="M4.666 4.667h6.5c1.405 0 2.107 0 2.611.337a2 2 0 0 1 .552.552c.337.504.337 1.206.337 2.61 0 2.342 0 3.512-.562 4.353a3.3 3.3 0 0 1-.92.92c-.84.561-2.01.561-4.351.561H8c-3.143 0-4.714 0-5.69-.976-.977-.977-.977-2.548-.977-5.69V5.295c0-1.21 0-1.816.254-2.27a2 2 0 0 1 .771-.772C2.813 2 3.418 2 4.63 2c.776 0 1.164 0 1.504.127.775.291 1.095.995 1.444 1.695L8 4.667"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_1678_1092">
        <path fill="#fff" d="M0 0h16v16H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export const CloseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
  >
    <g stroke="#FB6B7A" strokeWidth="1.5" clipPath="url(#clip0_1850_577)">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m10 6-4 4m4 0L6 6"
      ></path>
      <path d="M1.666 8c0-2.986 0-4.478.928-5.406.927-.927 2.42-.927 5.406-.927s4.478 0 5.406.927c.927.928.927 2.42.927 5.406s0 4.478-.927 5.406c-.928.927-2.42.927-5.406.927s-4.479 0-5.406-.927c-.928-.928-.928-2.42-.928-5.406Z"></path>
    </g>
    <defs>
      <clipPath id="clip0_1850_577">
        <path fill="#fff" d="M0 0h16v16H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export const UserIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    fill="none"
    viewBox="0 0 40 40"
  >
    <rect
      width="39"
      height="39"
      x="0.5"
      y="0.5"
      fill="#1B9C85"
      stroke="#49B09D"
      rx="9.5"
    ></rect>
    <path
      fill="#fff"
      d="M20 10c-2.62 0-4.75 2.13-4.75 4.75 0 2.57 2.01 4.65 4.63 4.74.08-.01.16-.01.22 0h.07a4.74 4.74 0 0 0 4.58-4.74c0-2.62-2.13-4.75-4.75-4.75M25.08 22.16c-2.79-1.86-7.34-1.86-10.15 0-1.27.84-1.97 1.99-1.97 3.22s.7 2.37 1.96 3.21c1.4.94 3.24 1.41 5.08 1.41s3.68-.47 5.08-1.41c1.26-.85 1.96-1.99 1.96-3.23-.01-1.22-.7-2.37-1.96-3.2"
    ></path>
  </svg>
);

export function YellowStarSVG() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="17"
      fill="none"
      className="star gold"
      viewBox="0 0 18 17"
    >
      <path
        fill="#ffc960"
        d="M7.532 1.39c.45-1.381 2.405-1.381 2.854 0l.93 2.865a1.5 1.5 0 001.427 1.037h3.012c1.453 0 2.057 1.86.882 2.713L14.2 9.775a1.5 1.5 0 00-.545 1.678l.93 2.865c.45 1.382-1.132 2.53-2.307 1.677l-2.437-1.77a1.5 1.5 0 00-1.764 0l-2.437 1.77c-1.175.854-2.757-.295-2.308-1.677l.931-2.865a1.5 1.5 0 00-.545-1.677l-2.437-1.77C.106 7.15.71 5.291 2.163 5.291h3.012a1.5 1.5 0 001.427-1.037l.93-2.864z"
      ></path>
    </svg>
  );
}

export function EmptyStarSVG() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="17"
      fill="none"
      className="star transparent"
      viewBox="0 0 18 17"
    >
      <path
        fill="#F1F1F1"
        d="M7.532 1.39c.45-1.381 2.405-1.381 2.854 0l.93 2.865a1.5 1.5 0 001.427 1.037h3.012c1.453 0 2.057 1.86.882 2.713L14.2 9.775a1.5 1.5 0 00-.545 1.678l.93 2.865c.45 1.382-1.132 2.53-2.307 1.677l-2.437-1.77a1.5 1.5 0 00-1.764 0l-2.437 1.77c-1.175.854-2.757-.295-2.308-1.677l.931-2.865a1.5 1.5 0 00-.545-1.677l-2.437-1.77C.106 7.15.71 5.291 2.163 5.291h3.012a1.5 1.5 0 001.427-1.037l.93-2.864z"
      ></path>
    </svg>
  );
}